import React from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationsDeferPopupProptypes } from 'src/components/NotificationsDeferPopup/propTypes';
import { Popup } from 'src/components/Popup';
import { useJobNotificationCreateDeferment } from 'src/hooks/jobNotificationDeferments/useJobNotificationCreateDeferment';
import s from './NotificationsDeferPopup.styles';

export const NotificationsDeferPopup = ({
  jobId,
  onClose,
  setNotificationsDeferment,
}) => {
  const { t } = useTranslation();
  const createNotificationDeferment = useJobNotificationCreateDeferment();

  const onSubmit = async () => {
    const createDeferResponse = await createNotificationDeferment({ jobId });

    if (createDeferResponse.data?.createJobNotificationDeferment?.success) {
      const { deferData } = createDeferResponse.data.createJobNotificationDeferment;
      const { deferFrom, deferUntil, id } = deferData;

      setNotificationsDeferment({
        deferFrom,
        deferUntil,
        id,
        jobId,
      });

      onClose();
    }
  };

  return (
    <Popup
      onClose={onClose}
      title={<s.Title>{t('DEFER_NOTIFICATIONS')}</s.Title>}
      >
      <s.Subtitle>{t('DEFER_NOTIFICATIONS_SUBTITLE')}</s.Subtitle>
      <s.Text>{t('DEFER_NOTIFICATIONS_TEXT')}</s.Text>
      <s.Text>{t('DEFER_NOTIFICATIONS_QUESTION')}</s.Text>
      <s.ActionButtonsWrapper>
        <s.ActionButton
          disabled={false}
          onClick={onSubmit}
          sm
        >
          {t('OK')}
        </s.ActionButton>
        <s.ActionButton
          disabled={false}
          onClick={onClose}
          orange
          outline
          sm
        >
          {t('CANCEL')}
        </s.ActionButton>
      </s.ActionButtonsWrapper>
    </Popup>
  );
};

NotificationsDeferPopup.propTypes = NotificationsDeferPopupProptypes;
